import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {ApiVisa, BaseApiTemplateService, Core2Config, PagingResponseModel} from '../../shared';
import {Observable} from 'rxjs';
import {GenericDocContainerModel} from '../../../../../../models/aggregates/generic_doc';
import {
  GenericDocHealthRecordQueryCriteriaClass,
  GenericDocHealthRecordCriteriaModelQuery
} from '../../../criteria/generic-doc-health-record-criteria.model';


@Injectable({
  providedIn: 'root'
})
export class CustomerHealthRecordService extends BaseApiTemplateService<GenericDocContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'customer-health-records';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'customer-health-records';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'customer-health-records';
    this.httpClient = http;
  }

  getCustomerByCriteria(visa: ApiVisa, criteria?: GenericDocHealthRecordQueryCriteriaClass):
    Observable<PagingResponseModel<GenericDocContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildEntityCriteriaCriteria = new GenericDocHealthRecordCriteriaModelQuery(criteria);
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(this.apiUrl + '/query?' +
      buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));
  }
}
